import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import escConstants from '../../constants';
import { useRoot } from '../../context/RootProvider';
import { DASHBOARD_ROUTE } from '../../routes/routePaths';

export interface ICheckAuthProps {
  children?: React.ReactNode;
  redirectTo?: string;
}

const CheckAuthElement = ({
  redirectTo = DASHBOARD_ROUTE,
  children,
}: ICheckAuthProps): JSX.Element => {
  const token = localStorage.getItem(escConstants.LOCAL_STORAGE_KEY.accessKey);

  const { auth: user } = useRoot();
  const userId = user?._id;

  if (token && userId) {
    return <Navigate to={redirectTo} replace />;
  }

  // ✅ Safe JSX-only return, never false/string/number
  return <>{children ?? <Outlet />}</>;
};

export default CheckAuthElement;
